export default function SectionHeading({ eyebrow, title, description, align = "left" }) {
  return (
    <div className={`mb-12 md:mb-16 ${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`}>
      {eyebrow && (
        <div className={`inline-flex items-center gap-2 ${align === "center" ? "justify-center" : ""}`}>
          <span className="h-px w-8 bg-[#2D5F3F]" />
          <span className="font-display text-xs uppercase tracking-[0.3em] text-[#2D5F3F] font-bold">{eyebrow}</span>
        </div>
      )}
      <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase leading-[0.95] text-[#0A0A0A]">
        {title}
      </h2>
      {description && (
        <p className="mt-6 text-base sm:text-lg text-black/75 leading-relaxed">{description}</p>
      )}
    </div>
  );
}
